<template>
  <div class="table-top">
    <div class="wordset">
      <ul>
        <li>
          <div class="pass-login">
            <span class="select-users-blk"><i class="bx bx-user"></i></span>
            <vue-select
              :options="Settingtable"
              id="settingtable"
              placeholder="Select IP"
            />
          </div>
        </li>
        <li>
          <div class="pass-login">
            <div class="cal-icon">
              <span><i class="bx bx-calendar"></i></span>
              <input
                type="text"
                class="form-control date-range bookingrange"
                ref="dateRangeInput"
                :input-format="dateFormat"
              />
            </div>
          </div>
        </li>
        <li>
          <a href="javascript:;" class="refine-filter"
            ><span><i class="bx bx-sort-down me-1"></i></span> Refine Filter</a
          >
        </li>
      </ul>
    </div>
    <div class="search-set">
      <div class="search-input">
        <a class="btn btn-searchset"><i class="bx bx-search"></i></a>
        <input
          type="text"
          v-model="search"
          placeholder="Search..."
          class="form-control form-control-sm"
          ariacontrols="DataTables_Table_0"
          @input="filterTable"
        />
      </div>
    </div>
  </div>
</template>
<script>
import "daterangepicker/daterangepicker.css";
import "daterangepicker/daterangepicker.js";
// import "moment/min/moment.min.js";
import { ref } from "vue";
import { onMounted } from "vue";
import moment from "moment";
import DateRangePicker from "daterangepicker";
export default {
  data() {
    return {
      dateFormat: "dd-MM-yyyy",
      search: [],
      Settingtable: ["Select User", "211.11.0.25", "211.03.0.11"],
    };
  },

  setup() {
    const dateRangeInput = ref(null);
    onMounted(() => {
      if (dateRangeInput.value) {
        const start = moment().subtract(6, "days");
        const end = moment();

        function booking_range(start, end) {
          start.format("M/D/YYYY") + " - " + end.format("M/D/YYYY");
        }

        new DateRangePicker(
          dateRangeInput.value,
          {
            startDate: start,
            endDate: end,
            ranges: {
              Today: [moment(), moment()],
              Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
              "Last 7 Days": [moment().subtract(6, "days"), moment()],
              "Last 30 Days": [moment().subtract(29, "days"), moment()],
              "This Month": [moment().startOf("month"), moment().endOf("month")],
              "Last Month": [
                moment().subtract(1, "month").startOf("month"),
                moment().subtract(1, "month").endOf("month"),
              ],
            },
          },
          booking_range
        );

        booking_range(start, end);
      }
    });
    return {
      dateRangeInput,
    };
  },
  mounted() {
    document.addEventListener("DOMContentLoaded", function () {
      const dataTable = document.getElementById("datanew");

      if (dataTable) {
        const table = $(dataTable).DataTable({
          bFilter: true,
          language: {
            search: "",
            searchPlaceholder: "Search...",
            class: "form-control form-control-sm",
            ariacontrols: "DataTables_Table_0",
            paginate: {
              next: ' <i class="fas fa-chevron-right"></i>',
              previous: '<i class="fas fa-chevron-left"></i>',
            },
          },
          initComplete: (settings, json) => {
            const filterInput = document.querySelector(".dataTables_filter input");

            if (filterInput) {
              document.getElementById("tableSearch").appendChild(filterInput);
              document.querySelector(".search-input").appendChild(filterInput);
            }
          },
        });
      }
    });
  },
};
</script>
